import { memo } from 'react';
import { StepViewComponentProps } from '../stepDescriptor/types';
import ExperimentalToolUseTaskComponent from './ExperimentalToolUseTaskComponent';

function ExperimentalToolUseViewComponent({
  readOnly,
  complete,
  responseIndex,
}: StepViewComponentProps) {
  return (
    <ExperimentalToolUseTaskComponent
      isPinnable
      isPinnedView={false}
      readOnly={readOnly}
      complete={complete}
      responseIndex={responseIndex}
    />
  );
}

export default memo(ExperimentalToolUseViewComponent);
